import { API } from '../helpers/fetcher'

export const getCards = async () => API.get('v1/user-cards')

export const deleteCards = async cardIds =>
  API.delete('v1/user-cards', { cardIds })
